import { Observable } from "rxjs";
import { UserData } from "@shared/models/user-data.model";

export abstract class AuthService {

  public abstract login(): void

  public abstract logout(): void

  public abstract get isAuthenticated$(): Observable<boolean>

  public abstract get userData$(): Observable<UserData>

  /**
   * @deprecated Do not use this method, it will be removed in the future.
   */
  public abstract getAccessToken(): Observable<string>

  /**
   * @deprecated Do not use this method, it will be removed in the future.
   */
  public abstract getIdToken(): Observable<string>

  /**
   * @deprecated Do not use this method, it will be removed in the future.
   */
  public abstract getRefreshToken(): Observable<string>

  /**
   * @deprecated Do not use this method, it will be removed in the future.
   */
  public abstract getMSGraphAccessToken(): Observable<string>

  /**
   * @deprecated Do not use this method, it will be removed in the future.
   */
  public abstract checkAuth(): Observable<{ isAuthenticated: boolean, userData: UserData | undefined}>

}
